const CACHE_KEY     = 'qfl_offline_questions';
const CACHE_TTL_MS  = 7 * 24 * 60 * 60 * 1000; // 7 jours
const MAX_POOL_SIZE = 100; // accumuler jusqu'à 100 questions distinctes

export function saveQuestionsToCache(questions) {
  try {
    const existing = loadQuestionsFromCache() || [];
    const existingIds = new Set(existing.map((q) => q._id || q.id));
    const fresh = questions.filter((q) => !existingIds.has(q._id || q.id));
    const merged = [...existing, ...fresh].slice(-MAX_POOL_SIZE);
    localStorage.setItem(CACHE_KEY, JSON.stringify({
      questions: merged,
      savedAt: Date.now(),
    }));
  } catch { /* localStorage plein — on ignore */ }
}

export function loadQuestionsFromCache() {
  try {
    const raw = localStorage.getItem(CACHE_KEY);
    if (!raw) return null;
    const { questions, savedAt } = JSON.parse(raw);
    if (Date.now() - savedAt > CACHE_TTL_MS) return null; // cache expiré
    return questions;
  } catch {
    return null;
  }
}

export function getCacheInfo() {
  try {
    const raw = localStorage.getItem(CACHE_KEY);
    if (!raw) return null;
    const { questions, savedAt } = JSON.parse(raw);
    return { count: questions.length, savedAt: new Date(savedAt) };
  } catch {
    return null;
  }
}
